interface IGetSummaryOfferInfo {
    once: number,
    monthly: number,
    connection: number,
    tariff: number,
}
/**
 * Собирает информацию для комментария при создании договора
 */
export const getSummaryOfferInfo = ({
    once,
    monthly,
    connection,
    tariff,
}: IGetSummaryOfferInfo) => {
    const inMonth = `Ежемесячно ${(monthly + tariff)}, тариф ${tariff}, `;
    const allEquipments = `оборудование ${monthly}.`;
    const oneTimePayment = `Разово ${once + connection}, подключение ${connection}, `;
    const itemsForOncePayment = `оборудование ${once}.`;
    const allSum = `Итого: ${once + monthly + connection + tariff}`;

    return inMonth +
        allEquipments +
        oneTimePayment +
        itemsForOncePayment +
        allSum;
};
